import React, { useRef } from 'react'
import { switchOpenedFromProfile } from '../../../../store/contributions/contributionsSlice'
import { addUrlToArray } from '../../../../store/common/commonSlice'
import { isUserPro } from '../../../../utils/isUserPro'
import { removeFavoritesContribution } from '../../../../api/contributions'
import { fetchFavoriteContributionsList } from '../../../../store/member/memberSlice'
import { Link, useLocation } from 'react-router-dom'
import { ContributionType } from '../../../../store/contributions/contributionsTypings'
import { useDispatch, useSelector } from 'react-redux'
import { RootState } from '../../../../store/rootReducer'
import { BackButtonType } from '../../../../store/common/commonSliceTyping'

import cls from './archiveContributionPreview.module.sass'
import { createLocalizedPath } from '../../../../utils/localizationHelpers'
import paths from '../../../../paths'
import moment from 'moment-mini'

interface Props {
    profile?: boolean
    contribution: ContributionType
}

const ArchiveContributionPreview = ({ contribution, profile = false }: Props) => {
    const ref = useRef(null)
    const dispatch = useDispatch()
    const location = useLocation()

    const user = useSelector((state: RootState) => state.member.user)
    const loggedIn = useSelector((state: RootState) => state.member.loggedIn)

    return (
        <div className={cls['archiveContributionPreview']}>
            <Link
                to={{
                    state: { profile: profile },
                    pathname: contribution.url
                }}
                onClick={() => {
                    dispatch(switchOpenedFromProfile('archive'))
                    dispatch(addUrlToArray(location.pathname))
                }}
                className={'contributionPreview_contributionTitle'}
            >
                <img
                    className={
                        (!loggedIn && contribution.pro === 1) ||
                        (user &&
                            !isUserPro(user.member_type) &&
                            contribution.pro === 1 &&
                            !(user && user.id === contribution.user.id))
                            ? 'onlyForPro'
                            : ''
                    }
                    ref={ref}
                    src={contribution.thumbnail}
                    alt={contribution.title}
                    onError={() => {
                        ref.current.src = require('./../../../../assets/404.png')
                        if (typeof document === 'object') ref.current.removeAttribute('height')
                    }}
                />
            </Link>
            <div className={cls['contributionPreview_description']} tabIndex={-1} data-descr={contribution.title}>
                <Link
                    to={{
                        state: { profile: profile },
                        pathname: contribution.url
                    }}
                    onClick={() => {
                        dispatch(switchOpenedFromProfile('archive'))
                        dispatch(addUrlToArray(location.pathname))
                    }}
                    className={'contributionPreview_contributionTitle'}
                >
                    {contribution.title}
                </Link>
                {contribution.description_stripped ? (
                    <span className={'contributionPreview_contributionDescription'}>
                        {contribution.description_stripped}
                    </span>
                ) : (
                    <></>
                )}
                <div>
                    <span
                        className={`${cls['contributionPreview_gender']} ${
                            cls['contributionPreview_gender_' + contribution.user.gender]
                        }`}
                    >
                        <Link
                            to={createLocalizedPath(paths.profile.toPath({ nick: contribution.user.nick }))}
                            className={`${cls['contributionPreview_nick']}`}
                        >
                            {contribution.user.nick}
                        </Link>
                    </span>
                    <p>
                        {contribution.user.country && (
                            <span className="contributionPreview_location">
                                {contribution.user.country}
                                {contribution.user.region && `, ${contribution.user.region}`}
                            </span>
                        )}
                    </p>
                </div>
                <div>{moment(contribution.submit_date * 1000).format('DD/MM/YYYY')}</div>
            </div>
        </div>
    )
}

export default ArchiveContributionPreview
